// extracted by mini-css-extract-plugin
module.exports = {"valueWrap":"value-wrap___15Tpc","valueWrapFlex":"value-wrap-flex___1w5OW"};